import { Space, Button } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type BasicSigningModuleSpecsFragment } from '../../../../api/fragments/BasicSigningModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdateForm from './UpdateForm';

export type UpdateDrawerProps = {
    onClose: () => void;
    visible: boolean;
    module: BasicSigningModuleSpecsFragment;
};

const UpdateDrawer = ({ onClose, visible, module }: UpdateDrawerProps) => {
    const { t } = useTranslation(['basicSigningModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('basicSigningModuleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateForm" htmlType="submit" type="primary">
                        {t('basicSigningModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('basicSigningModuleDetails:updateDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdateDrawer;

export const useUpdateDrawer = (module: BasicSigningModuleSpecsFragment) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <UpdateDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
